module.exports = __webpack_public_path__ + "static/media/no-report.60beac43.svg";